module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/settings/common/setting-section-header/setting-section-header.scss
// module id = ./web/modern/components/settings/common/setting-section-header/setting-section-header.scss
// module chunks = 0